module.exports = __webpack_public_path__ + "img/webnew-salon2-content-p6.998988e6.png";